@if (globalService.barsVisibility()) {
  <div class="canvas__bottom-right-bar canvas__bar" @fadeIn @fadeOut>
    <div class="flex items-center justify-between">
      <app-zoom-menu [canvas]="canvas()" [zoom]="zoom()"></app-zoom-menu>
      <app-help-menu></app-help-menu>
    </div>
  </div>
}
